import React from "react"
import PropTypes from "prop-types"

import "./ProgressBar.css"

const ProgressBar = ({ progress = 0 }) => {
  return (
    <div className="progress-bar-container">
      <div className="progress-bar">
        <span className="progress-bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <span>{progress}% Completed</span>
    </div>
  )
}

ProgressBar.propTypes = {
  progress: PropTypes.number
}

export default ProgressBar
